module.exports = __webpack_public_path__ + "img/chadle3_2.248063a1.png";